import React from 'react';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

// components
import ScriptFlowProgress from 'common/ScriptFlowProgress';

const baseString = 'vra-script-flow-step-header';
const classString = classNames({
  [`${baseString}`]: true
});

const ScriptFlowStepHeader = ({
  isAdvancedScripting,
  isLastStep,
  numSteps,
  step,
  stepTitleTextKey
}) => {
  const suffix = isAdvancedScripting && isLastStep ? '__advanced-final' : '';

  return (
    <section className={classString}>
      <header className={`${baseString}__body${suffix}`}>{getMessage(stepTitleTextKey)}</header>
      <footer className={`${baseString}__footer${suffix}`}>
        <ScriptFlowProgress currentStep={step} numSteps={numSteps} />
      </footer>
    </section>
  );
};

ScriptFlowStepHeader.propTypes = {
  isAdvancedScripting: propTypes.bool,
  isLastStep: propTypes.bool,
  numSteps: propTypes.number.isRequired,
  step: propTypes.number.isRequired,
  stepTitleTextKey: propTypes.string
};

export default ScriptFlowStepHeader;
